module.exports = __webpack_public_path__ + "img/banner1-sm.c0de41dc.jpg";